export const PROJECT_NAME =
    window.__CONFIG__?.PROJECT_NAME ?? "Unknown";

export const CHAT_URL = 'https://t.me/web3islands_chat';
